// extracted by mini-css-extract-plugin
export var closeButton = "_fq-2";
export var closeButtonIcon = "_fq-3";
export var lightboxContent = "_fq-1";
export var lightboxOverlay = "_fq-0";